define('views/blocks/ListingMenuView',['underscore','jquery','backbone','app','SubView'],
    function (_,$,Backbone,app,SubView) {

    //
    // Listing Menu View
    // représente le bloc latéral, contenant le menu de navigation des catégories
    //

        var view;

    return Backbone.View.extend(SubView).extend({
        initialize:function(){

            view = this;
            view.subviews = [];

            var cart = app.getCart();

            view.listenTo(app, 'listingCategoryChange', view.onCategoryChange);
            view.listenTo(app, 'categoryUpdate', view.onCategoryUpdate);
            view.listenTo(app,'displayCategory',view.displayCategory);
            view.listenTo(app, 'listingFilterChange', view.onCartChangeContext);
            view.listenTo(cart,'deliveryUpdate',view.onCartChangeContext);
            view.listenTo(cart,'changeContext',view.onCartChangeContext);
            view.listenTo(app.getCustomer(),'login logout',view.onCartChangeContext);

            view.menuLiEl = view.$('li');
            view.onCartChangeContext();
        },

        onCategoryChange:function(id_category){
            this.activateCategory(id_category);
        },

        onCategoryUpdate:function(category){
            var el = this.$('.category-'+category.id);
            el.toggleClass('disabled',!category.isActiveInContext(true));
        },

        activateCategory:function(id_category){
            this.$('li.active').removeClass('active');
            this.$('.category-'+id_category).addClass('active');
        },

        displayCategory: function(id_category){

            var categoryMenuEl = view.$('.category-' + id_category);

            view.menuLiEl.removeClass('active active-next active-previous');
            categoryMenuEl.addClass('active');
            categoryMenuEl.prevAll().not(".disabled").first().addClass('active-previous');
            categoryMenuEl.nextAll().not(".disabled").first().addClass('active-next');

            if (app.isMobile()) { // Mobile action
                view.$el.toggleClass('active',!app.get('isListingAllCategories')); // Retour à la liste des catégories
            }
        },

        onCartChangeContext:function(){
            var view = this,
                cart = app.getCart(),
                categories = app.getCategories().allMenuCategories();
            categories.each(function(category){
                var el = view.$('.category-'+category.id);
                el.toggleClass('disabled',!category.isActiveInContext(true,cart));
            });
            var activeDisabledCategory = view.$('.active.disabled');
            if(activeDisabledCategory.get(0)){
                // si la catégorie actuelle est désactivée à cause des filtres
                var altCatLink = activeDisabledCategory.siblings('li:not(.disabled)').find('a')
                if(altCatLink.length){
                    // on cherche une autre catégorie
                    altCatLink.first().click();
                }
            }
            view.render();
        },

    });
});
